import React, { useEffect, useRef } from "react";
import { IoClose } from "react-icons/io5";
import "../../Assets/css/MobileDropdownModal.css";

const MobileDropdownModal = ({
  isOpen,
  onClose,
  title,
  className,
  children,
  userData,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    function handleOutsideClick(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={`mobile-modal-overlay ${className || ""}`}>
      <div className="mobile-modal-box" ref={modalRef}>
        <div className="mobile-modal-line"></div>
        <div className="mobile-modal-header">
          <h4 style={{ fontFamily: userData?.pageTheme?.pageFont }}>{title}</h4>
        </div>

        {/* Modal Content */}
        <div className="mobile-modal-content">
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default MobileDropdownModal;
